export enum ActivityTypes {
  FIND_THE_LETTER = 'find-the-letter',
  FIND_THE_OBJECTS = 'find-the-objects',
  GUESS_THE_ORDER = 'guess-the-order',
  GUESS_WHERE = 'guess-where',
  GUESS_WHO = 'guess-who',
  FEELINGS_MATCH = 'feelings-match',
  MATCH_IT_TRASH_IT = 'match-it-trash-it',
  PRACTICE_BOOK = 'practice-book',
  READ_ALOUD = 'read-aloud',
  READ_STORY = 'read-story',
  SOUND_OUT_WORDS = 'sound-out-words',
  STARTING_SOUND = 'starting-sound',
  WDT = 'wet-dry-try',
}

export enum TelemetryEvents {
  ACCESS_ACTIVITY = 'accessActivity',
  ACCESS_ACTIVITY_PAGE = 'accessActivityPage',
  ACCESS_HELP = 'accessHelp',
  ACCESS_LINK = 'accessLink',
  ACCESS_PAGE = 'accessPage',
  ACCESS_REWARDS = 'accessRewards',
  ACCESS_RESOURCE = 'accessResource',
  COMPLETE_ACTIVITY = 'completeActivity',
  COMPLETE_ASSIGNMENT = 'completeAssignment',
  LOGIN_SUCCESS = 'loginSuccess',
  OPEN_MESSAGE = 'openMessage',
  READ_BOOK = 'readBook',
  SEND_MESSAGE = 'sendMessage',
  TEACHING_ORDER_CHANGED = 'teachingOrderChanged',
  UPDATE_LOCALE = 'updateLocale',
  VIEW_TAB = 'viewTab',
}
